module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/tools_icon-021051568020c6e72f01528a240da9fd.svg";